import React, { useEffect, useState } from 'react'
import swal from 'sweetalert2';
import { getUnAssignedPlayers, getUnSoldPlayer } from '../api/playerAPI';
import PlayerTable from './PlayerTable';

const UnsoldPlayer = () => {

    const [playerList,          setPlayerList]          = useState([]);
    const [loading,             setLoading]             = useState(false);

    useEffect(() => {
        fetchUnSoldPlayers();
    }, [])

    const fetchUnSoldPlayers = async () => {
        try {
            setLoading(true);
            const players = await getUnSoldPlayer();
            setPlayerList(players);             
            setLoading(false);
        } catch (error) {
            setLoading(false);
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }

    return (
        <>
            <PlayerTable
                from='unsold'
                playerList={playerList}
                loading={loading}
            />
        </>
    )
}

export default UnsoldPlayer